import {ScheduleDto, SchedulePageDto,} from "../../../../types/schedule/schedule-dto";
import {convertScheduleDtoToSchedule} from "../../../../utils/converter/schedule/schedule-converter";
import {ScheduleState} from "../../../type/schedule-state";

interface Action {
    type: string;
    payload: {
        schedulePageDto: SchedulePageDto;
    };
}

export const setSchedulePageDispatch = (
    state: ScheduleState,
    action: Action
) => {
    const {schedulePageDto} = action.payload;

    state.schedulePage = {
        contents: schedulePageDto.contents.map((scheduleDto: ScheduleDto) => {
            return convertScheduleDtoToSchedule(scheduleDto);
        }),
        first: schedulePageDto.first,
        last: schedulePageDto.last,
        page: schedulePageDto.page,
        totalPages: schedulePageDto.totalPages,
        totalElements: schedulePageDto.totalElements,
    };
};
